import { Link } from "react-router-dom";

export const Logo = ({ testId = "brand-logo" }) => (
  <Link to="/" data-testid={testId} className="group flex items-center gap-2.5" aria-label="TRACE home">
    <img
      src="/trace-mark.png"
      alt=""
      width="40"
      height="33"
      className="h-8 w-auto mix-blend-screen transition-transform duration-300 group-hover:-translate-y-0.5"
    />
    <span className="font-heading text-lg font-semibold tracking-[0.28em] text-white">TRACE</span>
  </Link>
);
